import { useState } from 'react';
import { Button } from '@/components/Button';
import { StatusPill } from '../StatusPill';
import { describeRequestStatus } from '../../dpRequests.definitions';
import { formatDayOffDates } from '../../utils/formatDayOffDates';
import { canCancelDayOff } from '../../utils/dayOffPolicy';
import { useCancelDayOff } from '../../hooks/data/useDpRequestMutations';
import { todayIsoDate } from '../../utils/dayOffPolicy';
import type { MyDayOffsSectionProps } from './myDayOffsSection.types';

export function MyDayOffsSection({ requests }: MyDayOffsSectionProps) {
    const cancel = useCancelDayOff();
    const [pendingId, setPendingId] = useState<string | null>(null);
    const todayIso = todayIsoDate();

    if (requests.length === 0) return null;

    return (
        <section className="space-y-3" aria-labelledby="my-day-offs">
            <h3 id="my-day-offs" className="font-montserrat text-base font-semibold text-raro-gray-900">Meus day-offs</h3>
            <ul className="space-y-3">
                {requests.map(request => {
                    const meta = describeRequestStatus(request);
                    return (
                        <li key={request.id} className="flex flex-col gap-3 rounded-2xl border border-raro-gray-200 bg-white p-4 sm:flex-row sm:items-center sm:justify-between">
                            <div className="min-w-0 space-y-1">
                                <div className="flex flex-wrap items-center gap-2">
                                    <StatusPill label={meta.label} tone={meta.tone} />
                                    <span className="text-xs text-raro-gray-500">{request.totalDays.toString().replace('.', ',')} dia(s)</span>
                                </div>
                                <p className="text-sm font-medium text-raro-gray-800">{formatDayOffDates(request.days).join(' · ')}</p>
                                {request.managerDecision?.note && request.status === 'rejected' && (
                                    <p className="text-xs text-raro-gray-600">Motivo: {request.managerDecision.note}</p>
                                )}
                            </div>
                            {canCancelDayOff(request, todayIso) && (
                                pendingId === request.id ? (
                                    <div className="flex gap-2">
                                        <Button variant="ghost" size="sm" onClick={() => setPendingId(null)} disabled={cancel.isPending}>
                                            Voltar
                                        </Button>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            loading={cancel.isPending}
                                            onClick={async () => {
                                                try {
                                                    await cancel.mutateAsync(request.id);
                                                } catch {
                                                    return;
                                                } finally {
                                                    setPendingId(null);
                                                }
                                            }}
                                        >
                                            Cancelar pedido
                                        </Button>
                                    </div>
                                ) : (
                                    <Button variant="outline" size="sm" onClick={() => setPendingId(request.id)}>
                                        Cancelar
                                    </Button>
                                )
                            )}
                        </li>
                    );
                })}
            </ul>
        </section>
    );
}
